import { useEffect, useRef, useState } from "react";

/**
 * Tracks mouse position (normalized -1..1) and scroll offset.
 * Applies smooth easing via requestAnimationFrame for buttery motion.
 * Used to drive cosmic parallax — different layers move at different speeds for depth.
 */
export const useCosmicParallax = () => {
  const [state, setState] = useState({ mx: 0, my: 0, sy: 0 });
  const targetRef = useRef({ mx: 0, my: 0, sy: 0 });
  const currentRef = useRef({ mx: 0, my: 0, sy: 0 });
  const rafRef = useRef(null);

  useEffect(() => {
    const handleMouse = (e) => {
      // Normalize to -1..1 from viewport center
      const x = (e.clientX / window.innerWidth) * 2 - 1;
      const y = (e.clientY / window.innerHeight) * 2 - 1;
      targetRef.current.mx = x;
      targetRef.current.my = y;
    };
    const handleScroll = () => {
      targetRef.current.sy = window.scrollY;
    };

    window.addEventListener("mousemove", handleMouse, { passive: true });
    window.addEventListener("scroll", handleScroll, { passive: true });

    const tick = () => {
      const ease = 0.08;
      currentRef.current.mx += (targetRef.current.mx - currentRef.current.mx) * ease;
      currentRef.current.my += (targetRef.current.my - currentRef.current.my) * ease;
      currentRef.current.sy += (targetRef.current.sy - currentRef.current.sy) * 0.15;
      setState({ ...currentRef.current });
      rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);

    return () => {
      window.removeEventListener("mousemove", handleMouse);
      window.removeEventListener("scroll", handleScroll);
      cancelAnimationFrame(rafRef.current);
    };
  }, []);

  return state;
};
